export default __webpack_public_path__ + "static/media/7.89ac55f1.jpg";